import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

import { makeLogger } from "@/shared/consola";
// eslint-disable-next-line no-unused-vars
const logger = makeLogger("player-upload.service");

const UPLOADS_ENDPOINT = `/uploads`;

const MULTIPART_FROM_DATA_HEADER = {
    headers: {
        "Content-Type": "multipart/form-data",
    },
};

function makeFileForm(fieldName, file) {
    const formData = new FormData();
    formData.set(fieldName, file);
    return formData;
}

function ajaxCallAsFormMultipart(ajaxCallFn) {
    return ajaxCallFn({ ...MULTIPART_FROM_DATA_HEADER }).catch(handleErrorByMessage());
}

export const pricingUploadService = {
    pricingImage({ file, uuid }) {
        logger.trace("pricingImage", "pricing", uuid, "file", file);
        const originalFile = file.originalFile ? file.originalFile : file;
        return ajaxCallAsFormMultipart((headers) =>
            ajaxCall.post(
                `${UPLOADS_ENDPOINT}/pricings/${uuid}/image`,
                makeFileForm("img", originalFile),
                {
                    ...headers,
                    onUploadProgress: (e) => file.onUploadProgress?.(e),
                }
            )
        );
    },
    pricingBackImage({ file, uuid }) {
        logger.trace("pricingBackImage", "pricing", uuid, "file", file);
        const originalFile = file.originalFile ? file.originalFile : file;
        return ajaxCallAsFormMultipart((headers) =>
            ajaxCall.post(
                `${UPLOADS_ENDPOINT}/pricings/${uuid}/back-image`,
                makeFileForm("img", originalFile),
                {
                    ...headers,
                    onUploadProgress: (e) => file.onUploadProgress?.(e),
                }
            )
        );
    },
    variantImage({ file, variantId }) {
        logger.trace("variantImage", "variant", variantId, "file", file);
        const originalFile = file.originalFile ? file.originalFile : file;
        return ajaxCallAsFormMultipart((headers) =>
            ajaxCall.post(
                `${UPLOADS_ENDPOINT}/variants/${variantId}/image`,
                makeFileForm("img", originalFile),
                {
                    ...headers,
                    onUploadProgress: (e) => file.onUploadProgress?.(e),
                }
            )
        );
    },
};
